import React from 'react';
import { Select, Tabs, Checkbox } from 'antd';
import styled from '@emotion/styled';
import { WastageReason } from 'services/api/dashboard';
import { CloseOutlined } from '@ant-design/icons';

import { useTranslate } from '@tolgee/react';
import Empty from 'components/Empty';
import { useDashboardFilter } from '../Filter/useFilter';
import { useGetReasonLabel } from 'hooks/business/refundReason/useGetReasonLabel';
import { useGetMercadoReasonLabel } from 'hooks/business/refundReason/useGetMercadoReasonLabel';

const Container = styled.div`
  display: flex;
  width: 400px;
  height: 300px;
  .ant-tabs-content {
    height: 100%;
    .ant-tabs-tabpane {
      height: 100%;
      overflow: auto;
    }
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }
  .ant-empty {
    width: 100%;
  }
`;
const Tag = styled.div`
  background: #f5f5f5;
  border: 1px solid rgba(231, 231, 231, 1);
  padding: 0 4px;
  display: flex;
  max-width: 150px;
  overflow: hidden;
  align-items: center;
  gap: 4px;
  max-width: 90px;
  margin-right: 4px;

  svg {
    cursor: pointer;
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
interface Props {
  onChange: (value: string[], type?: WastageReason['type']) => void;
  value?: string[];
  reasons: WastageReason[];
}

const ReasonSelector = (props: Props) => {
  const { onChange, value = [], reasons } = props;
  const { t } = useTranslate();
  const filterCtx = useDashboardFilter();
  const { getReasonLabel } = useGetReasonLabel();
  const getMercadoReasonLabel = useGetMercadoReasonLabel();

  return (
    <Select
      placeholder={t('ViewDashboard.选择损耗原因')}
      dropdownMatchSelectWidth={false}
      maxTagCount={2}
      allowClear
      value={value}
      showArrow
      onClear={() => {
        onChange([], undefined);
      }}
      tagRender={(node) => {
        return (
          <Tag>
            {filterCtx.platform === 'MERCADO' ? (
              <span className="text">{getMercadoReasonLabel(node.value)}</span>
            ) : (
              <span className="text">{getReasonLabel(node.value, filterCtx.platform)}</span>
            )}
            <CloseOutlined onClick={node.onClose} />
          </Tag>
        );
      }}
      mode="multiple"
      dropdownRender={(node) => (
        <Container>
          {!reasons.length && <Empty />}
          {reasons.length ? (
            <Tabs
              tabPosition="left"
              onTabClick={(value: any) => {
                const target = reasons.find((x) => x.type === value);
                onChange(target?.reason ?? [], target?.type);
              }}
            >
              {reasons?.map((x) => {
                return (
                  <Tabs.TabPane tab={t(x.type)} key={x.type}>
                    {x.reason.map((r) => (
                      <div>
                        <Checkbox
                          key={r}
                          checked={value?.includes(r)}
                          onChange={(e) => {
                            const { checked } = e.target;
                            if (checked) {
                              onChange([...value, r], x.type);
                            } else {
                              onChange(
                                value.filter((x) => x !== r),
                                x.type,
                              );
                            }
                          }}
                        >
                          {getReasonLabel(r, filterCtx.platform)}
                        </Checkbox>
                      </div>
                    ))}
                  </Tabs.TabPane>
                );
              })}
            </Tabs>
          ) : null}
        </Container>
      )}
    />
  );
};

export default ReasonSelector;
